import styled from 'styled-components'
import moment from 'moment'
import { formatReadOnlyField } from '../../../helpers/formUtils'

const DetailDates = ({
  studyDetails = null,
}) => {

  const formatDate = (value) => {
    if (value) {

      // "pending_results_returned" and "pending_results_submitted" sometimes comes in as a string, sometimes as an arrays of strings
      if (Array.isArray(value)) {
        value = value[0]
      }

      return moment(value).format("DD-MMM-YYYY")
    }
    return 'N/A'
  }

  const formatResultsDate = (connex_data) => {
    if (connex_data?.results_first_submitted || connex_data?.pending_results_submitted) {

      let newResultsPostedDate = null;
      // "pending_results_returned" and "pending_results_submitted" sometimes comes in as a string, sometimes as an arrays of strings

      //pending_results_submitted > results_first_submitted > "N/A"
      if (studyDetails?.ctg_data?.results_first_submitted) {
        newResultsPostedDate = studyDetails?.ctg_data?.results_first_submitted
      }
      else if (connex_data?.pending_results_submitted) {
        if (Array.isArray(connex_data?.pending_results_submitted)) {
          newResultsPostedDate = connex_data?.pending_results_submitted[0]
        } else {
          newResultsPostedDate = connex_data?.pending_results_submitted
        }
      }

      if (newResultsPostedDate) {
        return moment(newResultsPostedDate).format("DD-MMM-YYYY")
      } else {
        return 'N/A'
      }
    }
    return 'N/A'
  }

  return (
    <DatesWrapper>
      <DatesPart>
        {formatReadOnlyField(
          'Synced with CTG on',
          formatDate(studyDetails?.synced_at),
        )}
      </DatesPart>

      <DatesPart>
        {formatReadOnlyField(
          'Results Posted on',
          formatDate(studyDetails?.ctg_data?.results_first_posted),
        )}
      </DatesPart>

      <DatesPart>
        {formatReadOnlyField(
          'Results First Submitted on',
          formatResultsDate(studyDetails?.ctg_data),
        )}
      </DatesPart>

      <DatesPart>
        {formatReadOnlyField(
          'Results First Submitted QC on',
          formatDate(studyDetails?.ctg_data?.results_first_submitted_qc),
        )}
      </DatesPart>

      {/* <DatesPart>
        {formatReadOnlyField(
          'Pending Results Submitted on',
          formatDate(studyDetails?.connex_data?.pending_results_submitted),
        )}
      </DatesPart> */}

      {/* <DatesPart>
        {formatReadOnlyField(
          'Pending Results Returned on',
          formatDate(studyDetails?.connex_data?.pending_results_returned),
        )}
      </DatesPart> */}

      {/* <DatesPart>
        {formatReadOnlyField(
          'Results First Submitted on',
          formatDate(studyDetails?.connex_data?.results_first_submitted),
        )}
      </DatesPart> */}

      {/* <DatesPart>
        {formatReadOnlyField(
          'Results First Submitted QC on',
          formatDate(studyDetails?.connex_data?.results_first_submitted_qc),
        )}
      </DatesPart> */}

      <DatesPart>
        {formatReadOnlyField(
          'Last Update Submitted on',
          formatDate(studyDetails?.ctg_data?.last_update_submitted),
        )}
      </DatesPart>

      <DatesPart>
        {formatReadOnlyField(
          'Last Update Submitted QC on',
          formatDate(studyDetails?.ctg_data?.last_update_submitted_qc),
        )}
      </DatesPart>

      <DatesPart>
        {formatReadOnlyField(
          'Last Update Posted on',
          formatDate(studyDetails?.ctg_data?.last_update_posted),
        )}
      </DatesPart>
    </DatesWrapper>
  );
}

export default DetailDates;

const DatesWrapper = styled.div`
  display flex;
  flex-wrap: wrap;
  width: 100%;
`

const DatesPart = styled.div`
  padding: 12px;
  width: 33%;
  display: flex;
  flex-direction: column;
  justify-content: center;
`

const DatesHeader = styled.div`
  font-size: 12px;
  color: rgb(22, 22, 22);
  margin-bottom: 5px;
`

const DatesContent = styled.div`
  font-size: 14px;
  color: rgb(22, 22, 22);
`